import api from '@api';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getProductsGridFetchSuccess, getProductsGridFetchFailure } from './reducer';
import { ProductsGridResType } from 'src/types/productsGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';

export const PRODUCT_GRID_URL = 'api/secure/products/grid';
export const PRODUCT_GRID_ALL_PROVIDERS_URL = 'api/secure/products/grid?forceAllProviders=true';

export interface GetProductGridCallPayloadType {
    params: GridRequestType;
    allProviders: boolean;
}

const getProductsGridFetchRequest = async (payload: GetProductGridCallPayloadType) => {
    const res = await api(
        'post',
        payload.allProviders ? PRODUCT_GRID_ALL_PROVIDERS_URL : PRODUCT_GRID_URL,
        payload.params
    );
    return res.data.data;
};

function* getProductsGridFetch(action: { type: string; payload?: GetProductGridCallPayloadType }) {
    try {
        let payloadData: GetProductGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select((state: RootStoreType) => state.productsGrid.data?.request);
            const allProviders: boolean = yield select((state: RootStoreType) => state.productsGrid.allProviders);
            if (params) {
                payloadData = {
                    params,
                    allProviders,
                };
            }
        }
        if (payloadData) {
            // @ts-ignore
            const response: ProductsGridResType = yield call((): any => getProductsGridFetchRequest(payloadData));
            yield put(getProductsGridFetchSuccess(response));
        } else {
            yield put(getProductsGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getProductsGridFetchFailure({ error }));
    }
}

export function* getProductsGridFetchWatch() {
    yield takeEvery('productsGrid/getProductsGridFetch', getProductsGridFetch);
}
